<template>
     <div class="NotFound">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card height="400" class="elevation-0" color="transparent" flat>
            <div class="display-1 mt-5 pt-7">Vous n'avez pas le droit d'accèder à cette page.</div>
            <div class="grey--text lighten-5">
                La page que vous essayez d'accéder n'a jamais existé dans cette réalité,
                ou a migré vers un univers parallèle.
            </div>
            <div class="paragraph-text mt-2">
              <br />
              <br />Essayez de revenir à la page d'accueil et de répéter votre action. Ou contactez le service d'assistance pour obtenir de l'aide.
              <br />
              <v-btn color="primary" :to="{name: 'dashboard'}" class="mt-5" icon><v-icon>mdi-home</v-icon></v-btn>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
    name: "notAllowed",
}
</script>
<style type="scss" scoped>
.NotFound{
    height:100%;
    background: url('https://i.imgur.com/JFYas77.png') no-repeat bottom right;
    background-size:900px;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 100vh;
    max-width: 100%;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/commons/notAllowed.vue